import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }).format(v || 0);

const buDonem = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

function MaasModal({ personel, donem, onSave, onClose }) {
  const [form, setForm] = useState({
    user_id: '',
    donem: donem || buDonem(),
    baz_maas: '',
    ek_ders_saati: '0',
    ek_ders_birim_ucret: '0',
    prim: '0',
    avans_kesinti: '0',
    diger_kesinti: '0',
    odeme_tarihi: new Date().toISOString().slice(0, 10),
    notlar: '',
  });
  const [saving, setSaving] = useState(false);

  const brutMaas = (parseFloat(form.baz_maas) || 0) +
    (parseFloat(form.ek_ders_saati) || 0) * (parseFloat(form.ek_ders_birim_ucret) || 0) +
    (parseFloat(form.prim) || 0);
  const netMaas = brutMaas - (parseFloat(form.avans_kesinti) || 0) - (parseFloat(form.diger_kesinti) || 0);

  const handleSubmit = async () => {
    if (!form.user_id || !form.baz_maas) {
      toast.error('Personel ve taban maaş zorunlu');
      return;
    }

    setSaving(true);

    // Verileri sayısal formata hazırla
    const payload = {
      ...form,
      baz_maas: parseFloat(form.baz_maas) || 0,
      prim: parseFloat(form.prim) || 0,
      ek_ders_saati: parseFloat(form.ek_ders_saati) || 0,
      ek_ders_birim_ucret: parseFloat(form.ek_ders_birim_ucret) || 0,
      avans_kesinti: parseFloat(form.avans_kesinti) || 0,
      diger_kesinti: parseFloat(form.diger_kesinti) || 0
    };

    try {
      await onSave(payload);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">💼 Maaş Hesapla & Oluştur</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="muh-grid-2">
          <div className="form-group">
            <label className="form-label">Personel *</label>
            <select
              className="form-input"
              value={form.user_id}
              onChange={e => setForm(f => ({ ...f, user_id: e.target.value }))}
            >
              <option value="">Seçin</option>
              {personel.map((p, index) => (
                // p.id'nin varlığından emin olun, gerekirse index kullanın ama value p.id olmalı
                <option key={p.id || index} value={p.id}>
                  {p.ad} {p.soyad}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Dönem (YYYY-MM)</label>
            <input className="form-input" value={form.donem} onChange={e => setForm(f => ({ ...f, donem: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Taban Maaş (₺) *</label>
            <input className="form-input" type="number" value={form.baz_maas} onChange={e => setForm(f => ({ ...f, baz_maas: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Prim (₺)</label>
            <input className="form-input" type="number" value={form.prim} onChange={e => setForm(f => ({ ...f, prim: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Ek Ders Saati</label>
            <input className="form-input" type="number" value={form.ek_ders_saati} onChange={e => setForm(f => ({ ...f, ek_ders_saati: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Ek Ders Birim (₺/saat)</label>
            <input className="form-input" type="number" value={form.ek_ders_birim_ucret} onChange={e => setForm(f => ({ ...f, ek_ders_birim_ucret: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Avans Kesinti (₺)</label>
            <input className="form-input" type="number" value={form.avans_kesinti} onChange={e => setForm(f => ({ ...f, avans_kesinti: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Diğer Kesinti (₺)</label>
            <input className="form-input" type="number" value={form.diger_kesinti} onChange={e => setForm(f => ({ ...f, diger_kesinti: e.target.value }))} />
          </div>
        </div>

        {/* Özet */}
        <div className="muh-grid-3" style={{ background: 'var(--bg-elevated)', borderRadius: 12, padding: '14px 16px', margin: '12px 0', gap: 10 }}>
          {[
            { l: 'Brüt Maaş', v: TL(brutMaas), c: 'var(--blue)' },
            { l: 'Toplam Kesinti', v: TL((parseFloat(form.avans_kesinti) || 0) + (parseFloat(form.diger_kesinti) || 0)), c: '#EF4444' },
            { l: 'Net Maaş', v: TL(netMaas), c: '#10B981' },
          ].map((i, k) => (
            <div key={k} style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: 'var(--font-ui)', fontWeight: 900, fontSize: '1.1rem', color: i.c }}>{i.v}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{i.l}</div>
            </div>
          ))}
        </div>

        <div className="form-group">
          <label className="form-label">Ödeme Tarihi</label>
          <input className="form-input" type="date" value={form.odeme_tarihi} onChange={e => setForm(f => ({ ...f, odeme_tarihi: e.target.value }))} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving || netMaas <= 0}>
            {saving ? <div className="spinner" style={{ width: 16, height: 16 }} /> : '💾 Maaş Oluştur'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function MaaslarPage() {
  const [maaslar, setMaaslar] = useState([]);
  const [personelList, setPersonelList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [donem, setDonem] = useState(buDonem());
  const [showModal, setShowModal] = useState(false);
  const [odemeId, setOdemeId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get(`/muhasebe/maaslar?donem=${donem}`);
      if (r.data.success) setMaaslar(r.data.data);
    } catch { } finally { setLoading(false); }
  }, [donem]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
  axios.get('/ogretmenler-listesi')
    .then((oRes) => {
      const ogretmenler = (oRes.data.data || []).map(o => ({
        // ESKİ HALİ: id: o.user_id || o.ogretmen_id || o.id,
        // YENİ HALİ: Önceliği doğrudan nesneden gelen user_id değerine veriyoruz
        id: o.user_id || o.id,
        ad: o.ad,
        soyad: o.soyad,
        rol: 'ogretmen'
      }));
      setPersonelList(ogretmenler);
    })
    .catch(() => { setPersonelList([]); });
}, []);

  const handleSave = async (form) => {
  console.log("Gönderilen Form:", form); // Hata anında buraya bakın, user_id ne geliyor?

  const userId = parseInt(form.user_id, 10);

  if (!userId || isNaN(userId)) {
    toast.error('Lütfen geçerli bir personel seçin');
    return;
  }

  try {
    const cleanForm = { ...form, user_id: userId };
    await axios.post('/muhasebe/maaslar', cleanForm);
    toast.success('Maaş oluşturuldu');
    setShowModal(false);
    load();
  } catch (e) {
    toast.error(e.response?.data?.message || 'Hata oluştu');
  }
};

  const handleOde = async (id, yontem) => {
    try {
      await axios.put(`/muhasebe/maaslar/${id}/ode`, { odeme_yontemi: yontem });
      toast.success('Maaş ödendi!');
      setOdemeId(null); load();
    } catch (e) { toast.error('Hata'); }
  };

  const toplamNet = maaslar.reduce((s, m) => s + parseFloat(m.net_maas || 0), 0);
  const toplamOdenen = maaslar.filter(m => m.durum === 'odendi').reduce((s, m) => s + parseFloat(m.net_maas || 0), 0);

  const ROL_ETIKET = { ogretmen: 'Öğretmen', rehber_ogretmen: 'Rehber', ogrenci_isleri: 'Öğrenci İşleri', muhasebe: 'Muhasebe', kurucu: 'Kurucu' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontWeight: 900 }}>💼 Maaş / Hakediş</h2>
          <div className="section-subtitle">Personel ödemeleri ve hakedişler</div>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Maaş Oluştur</button>
      </div>

      {/* Dönem seçici + özet */}
      <div className="card animate-fadeInUp stagger-1 muh-filter-row" style={{ justifyContent: 'space-between', gap: 12 }}>
        <div className="muh-filter-row" style={{ alignItems: 'center', gap: 12 }}>
          <span style={{ fontWeight: 700 }}>Dönem:</span>
          <input className="form-input" type="month" value={donem} onChange={e => setDonem(e.target.value)} style={{ width: 160 }} />
        </div>
        <div className="muh-filter-row" style={{ gap: 24 }}>
          {[
            { l: 'Toplam Maaş', v: TL(toplamNet), c: 'var(--blue)' },
            { l: 'Ödenen', v: TL(toplamOdenen), c: '#10B981' },
            { l: 'Bekleyen', v: TL(toplamNet - toplamOdenen), c: '#F59E0B' },
          ].map((i, k) => (
            <div key={k} style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: 'var(--font-ui)', fontWeight: 900, color: i.c }}>{i.v}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{i.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Tablo */}
      <div className="card animate-fadeInUp stagger-2" style={{ padding: 0 }}>
        {loading ? (
          <div className="page-loader" style={{ minHeight: 200 }}><div className="spinner" /></div>
        ) : maaslar.length === 0 ? (
          <div className="empty-state" style={{ padding: 56 }}>
            <div style={{ fontSize: '3rem' }}>💼</div>
            <h3>{donem} dönemine ait maaş kaydı yok</h3>
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Personel</th><th>Rol</th>
                  <th style={{ textAlign: 'right' }}>Taban</th>
                  <th style={{ textAlign: 'right' }}>Ek Ders</th>
                  <th style={{ textAlign: 'right' }}>Prim</th>
                  <th style={{ textAlign: 'right' }}>Kesinti</th>
                  <th style={{ textAlign: 'right' }}>Net Maaş</th>
                  <th>Durum</th><th></th>
                </tr>
              </thead>
              <tbody>
                {maaslar.map((m, i) => (
                  <tr key={i}>
                    <td style={{ fontWeight: 700 }}>{m.ad} {m.soyad}</td>
                    <td><span className="badge badge-muted">{ROL_ETIKET[m.rol] || m.rol}</span></td>
                    <td style={{ textAlign: 'right', color: 'var(--text-secondary)' }}>{TL(m.baz_maas)}</td>
                    <td style={{ textAlign: 'right', color: '#3B82F6' }}>{TL(m.ek_ders_tutar)}</td>
                    <td style={{ textAlign: 'right', color: '#10B981' }}>{TL(m.prim)}</td>
                    <td style={{ textAlign: 'right', color: '#EF4444' }}>{TL((parseFloat(m.avans_kesinti) || 0) + (parseFloat(m.diger_kesinti) || 0))}</td>
                    <td style={{ textAlign: 'right', fontFamily: 'var(--font-ui)', fontWeight: 900, color: 'var(--blue)', fontSize: '1rem' }}>{TL(m.net_maas)}</td>
                    <td>
                      <span className="badge" style={{
                        background: m.durum === 'odendi' ? '#D1FAE5' : '#FEF3C7',
                        color: m.durum === 'odendi' ? '#065F46' : '#92400E',
                      }}>
                        {m.durum === 'odendi' ? '✅ Ödendi' : '⏳ Bekliyor'}
                      </span>
                    </td>
                    <td>
                      {m.durum === 'bekliyor' && (
                        <button className="btn btn-sm"
                          style={{ background: '#10B981', color: 'white', border: 'none' }}
                          onClick={() => { if (window.confirm(`${m.ad} ${m.soyad} - ${TL(m.net_maas)} ödemesi onaylanıyor?`)) handleOde(m.id, 'banka_havalesi'); }}>
                          💳 Öde
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showModal && <MaasModal personel={personelList} donem={donem} onSave={handleSave} onClose={() => setShowModal(false)} />}
    </div>
  );
}
